import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import { CartProvider } from "./contexts/CartContext";
import { AuthProvider } from "./contexts/AuthContext";
import { UserProvider } from "./contexts/UserContext";

import Header from "./components/Header";
import Footer from "./components/Footer";
import WhatsAppFloat from "./components/WhatsAppFloat";
import ChatWidget from "./components/ChatWidget";
import PromoBanner from "./components/PromoBanner";
import CartFloat from "./components/CartFloat";

import Home from "./pages/Home";
import Catalog from "./pages/Catalog";
import Cotizar from "./pages/Cotizar";
import Contacto from "./pages/Contacto";
import Cart from "./pages/Cart";
import Login from "./pages/Login";
import Register from "./pages/Register";
import MisPedidos from "./pages/MisPedidos";

import AdminLogin from "./pages/admin/Login";
import AdminLayout from "./pages/admin/AdminLayout";
import Dashboard from "./pages/admin/Dashboard";
import Orders from "./pages/admin/Orders";
import Products from "./pages/admin/Products";
import Categories from "./pages/admin/Categories";
import Sections from "./pages/admin/Sections";
import Quotes from "./pages/admin/Quotes";
import Settings from "./pages/admin/Settings";
import Discounts from "./pages/admin/Discounts";

const PublicShell = ({ children }) => {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");
  const isAuth = ["/login", "/registro"].includes(location.pathname);
  if (isAdmin) return <>{children}</>;
  if (isAuth) return <>{children}</>;
  return (
    <>
      <PromoBanner />
      <Header />
      <main>{children}</main>
      <Footer />
      <WhatsAppFloat />
      <CartFloat />
      <ChatWidget />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <UserProvider>
          <CartProvider>
            <BrowserRouter>
              <PublicShell>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/3d" element={<Catalog />} />
                  <Route path="/papeleria" element={<Catalog />} />
                  <Route path="/cotizar" element={<Cotizar />} />
                  <Route path="/contacto" element={<Contacto />} />
                  <Route path="/carrito" element={<Cart />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/registro" element={<Register />} />
                  <Route path="/mis-pedidos" element={<MisPedidos />} />

                  <Route path="/admin/login" element={<AdminLogin />} />
                  <Route path="/admin" element={<AdminLayout />}>
                    <Route index element={<Dashboard />} />
                    <Route path="orders" element={<Orders />} />
                    <Route path="products" element={<Products />} />
                    <Route path="sections" element={<Sections />} />
                    <Route path="categories" element={<Categories />} />
                    <Route path="quotes" element={<Quotes />} />
                    <Route path="discounts" element={<Discounts />} />
                    <Route path="settings" element={<Settings />} />
                  </Route>
                </Routes>
              </PublicShell>
            </BrowserRouter>
            <Toaster position="top-right" richColors />
          </CartProvider>
        </UserProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
